///Import react section
import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import withauthenticatedLayout from '../layouts/withauthenticatedLayout';
import {loadSacQualityFromBackEnd} from '../../store/sacsQuality/SacsQualityActions';
import { connect } from 'react-redux';
import {cancelWorflowQualityFromBackend} from '../../store/workflows/workflowActions';
import CancelWorkflow from '../common/CancelWorkflow';

class CancelContainer extends Component {
  constructor (props) {
    super(props);
    autoBind(this);
    this.state = {

    }
  }

    /**
    * componentDidMount
    */
   componentDidMount() {
    let sacQualityToken = this.props.match.params.token;
    this.props.loadSacQuality(sacQualityToken);
}

      /**
     * Cancel a sac quality from back end
     */
    onCancelWorkflowsDocument(cancelComment, razonForCancel){
      let token =this.props.match.params.token;
      this.props.cancelWorflowQualityFromBackend(token, cancelComment, razonForCancel)
      .then(() =>{
        this.props.history.push(`/sacsquality/${this.props.sacQuality.token}`)
      }).catch(() =>{
          this.setState({
              showToaster: true,
              toasterMessage: <Translate id="common.errorToSave" />,
              toasterVariant: "error",
          })
      })
  }

  render () {
    return (
      <CancelWorkflow
        {...this.props}
          workflow= {this.props.qualityFailure}
          onCancelWorkflowsDocument={this.onCancelWorkflowsDocument}
          isSaving={this.props.isCancel}
          link = {'sacsquality'}

      />
    )
  }
}

/**
 *  Defines the properties injecteded from the store to view container
 *
 * @param {*} state
 * @returns
 */
function mapStateToProps(state) {
    let sacQuality = state.sacsQuality.get("sacQuality");
   return {
      isCancel: state.workflow.get('isCancel'),
      sacQuality: sacQuality ? sacQuality.toJS() : null,
  }
}

/**
 * Defines the actions injectes to the component
 *
 * @param {*} state
 * @returnss
 */
const mapDispatchToProps = dispatch => {
  return {
    loadSacQuality: (token) => {
        return dispatch(loadSacQualityFromBackEnd(token));
    },
    cancelWorflowQualityFromBackend: (token, cancelComment, razonForCancel) => {
        return dispatch(cancelWorflowQualityFromBackend(token, cancelComment, razonForCancel));
    },
    
  }
}

export default withauthenticatedLayout((withRouter) (connect(mapStateToProps, mapDispatchToProps)(CancelContainer)));